(function () {
  'use strict';
  if (window.__agcfTrack) return;
  window.__agcfTrack = true;
  var VKEY = 'agcf8:vid';   /* shared with agcf.js - ONE visitor id */
  var SKEY = 'agcf8:track:v1';
  var GAP = 1800000;        /* 30 min of silence closes a session */
  var HCAP = 16;            /* handles kept: engaged first, then LRU */
  var RCAP = 12;            /* render links kept per handle */
  var WAIT = 3000;          /* trailing debounce on the beacon */
  var BMAX = 40;            /* hard cap on beacons per page load */
  var FCAP = 8;             /* finish codes kept per handle - a SET */
  var VMIN = 3000;          /* an unengaged row younger than this bounced */
  var FWD = 400;            /* this soon after a real click = a forward */
  var SVER = 2;             /* selector version, stamped on new rows */
  var JWAIT = 900, JMAX = 6; /* empty-cart re-read gap, then give up */
  /* THE SCOPE LAW (R43): guide, then the enumerated custom-finish
     surface, then the THEME's stock swatch. Gates CFA-09/CFA-10. */
  var CG = '[data-agcfg-help],[data-agcfg]';
  var CM = '.agcf-ghost-cell,.agcf-band,[data-agcf-orphan],[data-agcf-ghost-panel]';
  var CS = '.ag-finish-card--selectable';
  var SW = '[data-agcf-sw]';
  var ATCB = '#add-to-cart-btn';
  /* IDENTITY comes from the loader tag: this ships on every product
     page, the wrapper only on customizable ones. The query below
     decides what ARMS, not who we are. */
  var SC = document.currentScript;
  var SD = (SC && SC.dataset) || {};
  if (SC && (SD.p || '') !== 'pdp') return;
  var host = document.querySelector('[data-agcf-r6]');
  var HANDLE = (SD.h
    || (host && host.getAttribute('data-agcf-handle')) || '').trim();
  if (!HANDLE) return;
  var GBASE = (SD.b
    || (host && host.getAttribute('data-agcf-gen-base')) || '')
    .trim().replace(/\/+$/, '');
  var sent = 0, timer = null, joined = false, lastReal = 0, jn = 0;
  function noop() {}
  /* the SAME validation agcf.js applies to the SAME key - the vid must
     be the one the render service already sees. */
  function readVid() {
    var v = null;
    try { v = localStorage.getItem(VKEY); } catch (e) {}
    if (typeof v !== 'string' || v.length < 8 || v.length > 64
        || /[^A-Za-z0-9-]/.test(v)) {
      v = (window.crypto && crypto.randomUUID) ? crypto.randomUUID()
        : ('v' + Date.now().toString(36)
           + Math.random().toString(36).slice(2, 12));
      try { localStorage.setItem(VKEY, v); } catch (e2) {}
    }
    return v;
  }
  var VID = readVid();
  /* one predicate, three readers: eviction, bounce guard, and the
     server's twin. A view is NOT an engagement. */
  function eng(h) {
    return !!(h && (h.cm || h.cg || h.cs || h.n || h.nbf));
  }
  function load() {
    var s = null;
    try { s = JSON.parse(localStorage.getItem(SKEY) || 'null'); } catch (e) {}
    if (!s || s.v !== 1 || !s.handles || typeof s.handles !== 'object') {
      s = { v: 1, handles: {} };
    }
    return s;
  }
  function save(s) {
    var ks = Object.keys(s.handles), i;
    if (ks.length > HCAP) {
      /* engaged outranks view-only, THEN newest: browsing must not
         evict the row that was configured. */
      ks.sort(function (a, b) {
        var A = s.handles[a] || {}, B = s.handles[b] || {};
        var d = (eng(B) ? 1 : 0) - (eng(A) ? 1 : 0);
        return d || ((B.z || 0) - (A.z || 0));
      });
      for (i = HCAP; i < ks.length; i++) delete s.handles[ks[i]];
    }
    try { localStorage.setItem(SKEY, JSON.stringify(s)); } catch (e) {}
  }
  /* EVERY event re-reads, mutates and re-writes: caching loses
     whichever tab wrote last. Clock-backwards counts as a gap. */
  function signal(mut) {
    var now = Date.now(), s = load(), h = s.handles[HANDLE], span;
    /* shapes come out of storage, so each is re-checked: under 'use
       strict' a write onto a string primitive THROWS. sv is stamped at
       CREATION, never advanced - an older row reads back 0 and the
       service declines to claim its clicked_module. */
    if (!h || typeof h !== 'object') {
      h = s.handles[HANDLE] = { cm: 0, cg: 0, cs: 0, r: [], fc: [],
                                n: 0, nbf: 0, cmn: 0, cgn: 0, csn: 0,
                                swn: 0, vn: 0, sv: SVER,
                                lg: 0, tot: 0, ns: 1,
                                s: { a: now, l: now }, f: now, z: now };
    }
    if (!h.s || typeof h.s.a !== 'number' || typeof h.s.l !== 'number') {
      h.s = { a: now, l: now };
    }
    if (!(h.r && h.r.push)) h.r = [];
    if (!(h.fc && h.fc.push)) h.fc = [];
    if ((now - h.s.l) > GAP || now < h.s.l) {
      span = h.s.l - h.s.a;
      if (span > 0) {
        if (span > (h.lg || 0)) h.lg = span;
        h.tot = (h.tot || 0) + span;
      }
      h.ns = (h.ns || 0) + 1;
      h.s.a = now;
    }
    h.s.l = now;
    h.z = now;
    if (typeof h.f !== 'number' || !h.f) h.f = now;
    if (mut) { try { mut(h, now); } catch (e) {} }
    save(s);
    return h;
  }
  function link(h, u, k, now) {
    /* a data: URI is the offline spacer, never a link anyone can open */
    if (!u || typeof u !== 'string' || u.indexOf('data:') === 0) return;
    for (var i = 0; i < h.r.length; i++) {
      if (h.r[i] && h.r[i].u === u) { h.r[i].t = now; return; }
    }
    h.r.unshift({ u: u, t: now, k: k });
    if (h.r.length > RCAP) h.r.length = RCAP;
  }
  /* the SET of the first FCAP codes touched, never the last one: the
     server unions it, and a last-value is not replay-idempotent. */
  function code(h, c) {
    if (typeof c !== 'string') return;
    c = c.trim();
    if (!c || c.length > 16 || h.fc.length >= FCAP) return;
    for (var i = 0; i < h.fc.length; i++) { if (h.fc[i] === c) return; }
    h.fc.push(c);
  }
  /* the OPEN session is folded into both durations: the server merges
     monotonically. Every counter is an ABSOLUTE total - max(x, x) = x
     makes a replay a no-op. */
  function shot(h) {
    var open = (h.s && h.s.l > h.s.a) ? (h.s.l - h.s.a) : 0;
    return { v: 1, h: HANDLE, sv: h.sv || 0,
             cm: h.cm ? 1 : 0, cg: h.cg ? 1 : 0, cs: h.cs ? 1 : 0,
             cmn: h.cmn || 0, cgn: h.cgn || 0, csn: h.csn || 0,
             swn: h.swn || 0, vn: h.vn || 0,
             fc: (h.fc && h.fc.slice) ? h.fc.slice(0, FCAP) : [],
             n: h.n || 0, nbf: h.nbf || 0,
             lg: Math.max(h.lg || 0, open),
             tot: (h.tot || 0) + open,
             ns: h.ns || 1, f: h.f || 0, z: h.z || 0,
             r: (h.r && h.r.slice) ? h.r.slice(0, RCAP) : [] };
  }
  /* never re-signals: the last real interaction IS the end of the
     session. text/plain keeps the POST preflight-free, the only shape
     sendBeacon answers. */
  function beacon() {
    if (timer) { clearTimeout(timer); timer = null; }
    if (!GBASE || sent >= BMAX) return;
    var s = load(), h = s.handles[HANDLE];
    if (!h) return;
    /* THE BOUNCE GUARD: a glance must not put a write on the box that
       serves paid renders. */
    if (!eng(h) && (Date.now() - (h.f || 0)) < VMIN) return;
    sent++;
    var u = GBASE + '/track?vid=' + encodeURIComponent(VID)
      + '&handle=' + encodeURIComponent(HANDLE);
    var body = JSON.stringify(shot(h));
    try {
      if (navigator.sendBeacon
          && navigator.sendBeacon(u, new Blob([body],
                                              { type: 'text/plain' }))) {
        return;
      }
    } catch (e) {}
    try {
      fetch(u, { method: 'POST', keepalive: true, mode: 'cors',
                 headers: { 'Content-Type': 'text/plain' },
                 body: body }).then(noop, noop);
    } catch (e2) {}
  }
  function later() {
    if (timer) return;
    timer = setTimeout(function () { timer = null; beacon(); }, WAIT);
  }
  /* THE JOIN KEY, once per page, and ONLY onto a cart that HAS a line:
     a cookie-less write MINTS a second cart. An empty cart re-reads on
     ONE held ladder that RE-ARMS if it ends unwritten (CFA-17). */
  function join() {
    if (joined) return;
    joined = true;
    var attrs = { _cf_vid: VID };
    var off = function () { joined = false; jn = 0; };
    var read = function () {
      try {
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(put, off);
      } catch (e) { off(); }
    };
    var put = function (cart) {
      try {
        if (cart && cart.attributes && cart.attributes._cf_vid === VID) {
          return;
        }
        if (!cart || !cart.item_count) {
          if (jn++ < JMAX) { setTimeout(read, JWAIT); return; }
          off();
          return;
        }
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: attrs })
        }).then(noop, noop);
      } catch (e) { off(); }
    };
    var known = null;
    try { known = window.__agcfCart; } catch (e) {} /* agcf.js publishes */
    if (known && known.item_count) { put(known); return; }
    read();
  }
  /* ONE listener, WINDOW capture: the theme's own ATC stopper sits on
     document capture ahead of us (CFA-P14), and the guide trigger stops
     the click travelling. Observational only, one closest() per click. */
  window.addEventListener('click', function (e) {
    try {
      var t = e && e.target, now, sw;
      if (!t || !t.closest) return;
      /* written in this gesture anyway; the press REFILLS the ladder. */
      if (t.closest(ATCB)) { jn = 0; join(); }
      /* below is the module, which a product page need not have. */
      if (!host) return;
      now = Date.now();
      /* THE FORWARD FILTER (CFA-11). Two synthetic clicks here repeat
         a click already counted; a third is a keyboard Enter whose only
         click is programmatic. Counters only - flags OR. */
      if (e.isTrusted) lastReal = now;
      else if (now - lastReal < FWD) return;
      if (t.closest(CG)) {
        signal(function (h) { h.cg = 1; h.cgn = (h.cgn || 0) + 1; });
      } else if (t.closest(CM)) {
        sw = t.closest(SW);
        signal(function (h) {
          h.cm = 1; h.cmn = (h.cmn || 0) + 1;
          if (sw) {
            h.swn = (h.swn || 0) + 1;
            code(h, sw.getAttribute('data-code'));
          }
        });
      } else if (t.closest(CS)) {
        signal(function (h) { h.cs = 1; h.csn = (h.csn || 0) + 1; });
      } else {
        return;
      }
      join();
    } catch (err) {}
  }, true);
  /* the dispatcher exists only where the module loads. Body frozen. */
  if (host) document.addEventListener('agcf:track', function (e) {
    try {
      var det = (e && e.detail) || {}, d = det.d || {};
      if (det.k === 'gen') { signal(null); join(); return; }
      if (det.k === 'render') {
        signal(function (h, now) {
          if (d.sim) return;   /* the offline simulation is not a render */
          h.n = (h.n || 0) + 1;
          link(h, d.url, d.hit ? 'hit' : 'gen', now);
        });
      } else if (det.k === 'bf') {
        /* the free sibling flip rides its OWN counter, never a render
           the visitor asked for. */
        signal(function (h, now) {
          h.nbf = (h.nbf || 0) + 1;
          link(h, d.url, 'bf', now);
        });
      } else {
        return;
      }
      join();
      later();
    } catch (err) {}
  });
  /* the send paths run while the page is torn down: the worst moment
     to raise. */
  document.addEventListener('visibilitychange', function () {
    try { if (document.visibilityState === 'hidden') beacon(); } catch (e) {}
  });
  window.addEventListener('pagehide', function () {
    try { beacon(); } catch (e) {}
  });
  /* THE VIEW SIGNAL (R43), LAST so the capture registration slice is
     unchanged: a view writes a row and calls nothing. Idle callback
     after DCL, gated on visibility - a prerender runs hidden. Gates
     CFA-12/CFA-13. */
  function view() {
    signal(function (h) {
      h.vn = (h.vn || 0) + 1;
      /* a view BRACKETS NOTHING (CFA-16) */
      if (!eng(h)) h.s.a = h.s.l;
    });
  }
  function look() {
    if (document.visibilityState === 'visible') { view(); return; }
    document.addEventListener('visibilitychange', function vv() {
      if (document.visibilityState !== 'visible') return;
      document.removeEventListener('visibilitychange', vv);
      view();
    });
  }
  function idle() {
    if (window.requestIdleCallback) {
      requestIdleCallback(look, { timeout: 2000 });
      return;
    }
    setTimeout(look, 0);
  }
  /* a deferred script sees 'interactive': schedule, never wait on a DCL
     that has fired. The rIC timeout is a DEADLINE (CFA-13). */
  if (document.readyState !== 'loading') idle();
  else document.addEventListener('DOMContentLoaded', idle);
})();
